import { FlowErrorType } from './error'
import { UploadedFileType } from './files'

export enum CustomerEligibilityOptions {
  ALL_CUSTOMERS = 'ALL_CUSTOMERS',
  FIRST_TIME_CUSTOMERS = 'FIRST_TIME_CUSTOMERS',
  LIFETIME_ORDER_COUNT = 'LIFETIME_ORDER_COUNT',
  SPECIFIC_CUSTOMERS = 'SPECIFIC_CUSTOMERS',
  CUSTOMER_SEGMENT = 'CUSTOMER_SEGMENT',
  SPECIFIC_PINCODES = 'SPECIFIC_PINCODES',
  UTM_PARAMS = 'UTM_PARAMS',
  PINCODE_RTO_RISK = 'PINCODE_RTO_RISK',
  CUSTOMER_RTO_RISK = 'CUSTOMER_RTO_RISK'
}

export enum RtoRiskStrategyOptions {
  GREATER_THAN = 'GREATER_THAN',
  LESS_THAN = 'LESS_THAN'
}

export type CustomerEligibilityStateType =
  | {
      type: CustomerEligibilityOptions.ALL_CUSTOMERS
    }
  | {
      type: CustomerEligibilityOptions.FIRST_TIME_CUSTOMERS
    }
  | {
      type: CustomerEligibilityOptions.LIFETIME_ORDER_COUNT
      minimumOrders: number | ''
      maximumEnabled: boolean
      maximumOrders: number | ''
    }
  | {
      type: CustomerEligibilityOptions.CUSTOMER_SEGMENT
      segmentIds: string[]
    }
  | {
      type: CustomerEligibilityOptions.SPECIFIC_CUSTOMERS
      uploadedFile?: UploadedFileType
      formData?: FormData
    }
  | {
      type: CustomerEligibilityOptions.SPECIFIC_PINCODES
      uploadedFile?: UploadedFileType
      formData?: FormData
    }
  | {
      type: CustomerEligibilityOptions.UTM_PARAMS
      utmData: UTMSelectorStateType[]
    }
  | {
      type: CustomerEligibilityOptions.PINCODE_RTO_RISK
      strategy: RtoRiskStrategyOptions
      score: number | ''
    }
  | {
      type: CustomerEligibilityOptions.CUSTOMER_RTO_RISK
      strategy: RtoRiskStrategyOptions
      score: number | ''
    }

export enum utmDataOptions {
  UTM_SOURCE = 'UTM_SOURCE',
  UTM_CAMPAIGN = 'UTM_CAMPAIGN',
  UTM_MEDIUM = 'UTM_MEDIUM',
  UTM_CONTENT = 'UTM_CONTENT'
}

export type UTMSelectorStateType = {
  key: utmDataOptions
  value: string[]
}

export type UTMSelectorDropdownOptionType = {
  label: string
  value: utmDataOptions
}

export type ActivePeriodStateType = {
  startDate: Date
  endDate?: Date
  endDateEnabled: boolean
}

export type CustomerEligibilityErrorStateType =
  | {
      type: CustomerEligibilityOptions.LIFETIME_ORDER_COUNT
      minimumOrders: FlowErrorType
      maximumOrders: FlowErrorType
    }
  | {
      type: CustomerEligibilityOptions.SPECIFIC_CUSTOMERS
      uploadedFile: FlowErrorType
    }
  | {
      type: CustomerEligibilityOptions.CUSTOMER_SEGMENT
      segmentIds: FlowErrorType
    }
  | {
      type: CustomerEligibilityOptions.SPECIFIC_PINCODES
      uploadedFile: FlowErrorType
    }
  | {
      type: CustomerEligibilityOptions.UTM_PARAMS
      utmData: FlowErrorType
    }
  | {
      type: CustomerEligibilityOptions.PINCODE_RTO_RISK
      score: FlowErrorType
    }
  | {
      type: CustomerEligibilityOptions.CUSTOMER_RTO_RISK
      score: FlowErrorType
    }

export type ActivePeriodErrorStateType = {
  startDate: FlowErrorType
  endDate: FlowErrorType
}
